import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import { convertItemsToTilesChannelCategory } from "../formatters/ItemFormatter";

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();
export default function (filter: string) {
  return (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default";

    const cacheKey = `${apiIdentifier}_${username}_live_categories`;
    const tileKey = `${filter}_${apiIdentifier}_${username}_live_categories`;

    const url = `/player_api.php?username=${username}&password=${password}&action=get_live_categories`;

    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }

    const result = api
      ._get(url)
      .then(channels => {
        // Validate response is an array
        if (!Array.isArray(channels)) {
          console.warn(`Live categories response is not an array:`, typeof channels);
          return [];
        }

        const results = channels;
        const existingTiles = leftoverTiles.get(tileKey) || [];
        const tiles = existingTiles.concat(convertItemsToTilesChannelCategory(results));

        console.log(`✅ Live categories processed: ${tiles.length} tiles`);
        return tiles;
      })
      .catch(error => {
        console.error(`❌ Live categories API call failed:`, error.message);
        cache.delete(cacheKey); // Remove from cache on error

        // Return empty array to prevent app crash
        return [];
      });

    cache.set(cacheKey, result);
    return result;
  };
}
